import React from 'react';

import CreditRefundAlert from './CreditRefundAlert';
import FraudRiskAlert from './FraudRiskAlert';

interface Props {
  userId: string;
}

/**
 * Customer risk warnings for the Admin Portal. Each alert fetches its own data and renders
 * nothing when it has nothing to say, so they stay independent of one another.
 */
export default function FraudWarning({ userId }: Props) {
  return (
    <>
      <FraudRiskAlert userId={userId} />
      <CreditRefundAlert userId={userId} />
    </>
  );
}
